<script>
  export let data;
  export let type = 'default';
</script>

<div class="footer-bottom">
  <div class="container container--medium">
    <div class="flexbox v-c h-sb">
      <div class="col col-40 col-m-full footer-bottom__col--1">
        <p class="text-small footer-bottom__copy">{@html data.copy}</p>
      </div>
      {#if type !== 'contacts'}
        <div class="col m-auto col-m-full footer-bottom__col--2">
          <img
            class="footer-bottom__logo"
            width="50"
            height="50"
            src={data.logo.src}
            alt={data.logo.alt}
          />
        </div>
      {/if}
      <div class="col col-40 col-m-full footer-bottom__col--3">
        {#if data.menu}
          <ul class="footer-bottom__menu">
            {#each data.menu as item}
              <li>
                <a class="text-small" href={item.url}>{item.title}</a>
              </li>
            {/each}
          </ul>
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .footer-bottom {
    @include resp-max('m') {
      color: var(--grey);
    }

    padding: 3.5rem 0;

    &__col {
      &--1 {
        @include resp-max('m') {
          order: 2;
        }
      }
      &--2 {
        @include resp-max('m') {
          order: 3;
        }
      }
      &--3 {
        @include resp-max('m') {
          order: 1;
        }
      }
    }

    &__copy {
      @include resp-max('m') {
        padding: 1.5rem 0 3rem;
        text-align: center;
      }
    }

    &__logo {
      margin: 0 auto;
    }

    &__menu {
      @include resp-max('m') {
        text-align: center;
      }
      @include resp-min('m') {
        display: flex;
        justify-content: flex-end;
        gap: 4rem;
      }

      li {
        @include resp-max('m') {
          padding: 0.5rem 0;
        }

        transition: all 0.2s;

        &:hover {
          @include gradient('blue', 135deg);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
</style>
